import { breadcrumb } from './breadcrumb';

export const notify = {
  breadcrumb,

  notification: {
    field: {
      type: 'Model',
      text: 'Text',
      created_at: 'Tanggal'
    },

    senders_update: {
      body: 'Status pengirim {name} berubah menjadi {status}.',
      success_amount:
        'Pengirim {name} telah disetujui. Anda akan dikenakan biaya {amount} sebulan.',
      success: 'Pengirim {name} telah disetujui.',
      error: 'Pengirim {name} telah ditolak.',
      on_deactivation: 'Pengirim {name} akan dinonaktifkan dalam 1-3 hari.',
      text_link: 'Buka halaman'
    },

    mailings_update: {
      moderation_success:
        'SMS mailing {name} disetujui. Pengiriman akan dilakukan pada {start_at}.',
      moderate_too_late:
        'SMS {name} tidak disetujui sebelum waktu pengiriman yang dijadwalkan. Mailigs ditolak.',
      pending: 'SMS mailing {name} disetujui.',
      rejected: 'SMS mailing {name} ditolak.',
      failed: 'SMS mailing {name} gagal.'
    },

    rates_update: {
      body:
        'Tarif layanan Anda telah diperbarui. Silakan lihat informasi rinci pada halaman "{link}".',

      type: {
        messaging: 'sms',
        voice: 'Komunikasi SMS',
        hlr: 'HLR',
        default: 'Komunikasi',
        number_verification: 'verifikasi'
      },

      link: {
        label: 'Rates'
      }
    },

    low_balance: {
      body:
        'Dana di akun Anda tidak cukup. Harap isi kembali saldo Anda untuk terus menggunakan layanan ZORRA.'
    },

    not_enough_money: {
      body: 'Saldo tidak memiliki cukup dana untuk verifikasi HLR file'
    },

    documents_update: {
      body: {
        approved: 'Dokumen disetujui.',
        rejected: 'Documen ditolak. Hubungi CS untuk detailnya.'
      }
    },

    export_complete: {
      body: 'File yang terkirim sudah selesai.',
      link: 'Unduh'
    },

    recording_export_complete: {
      body: 'File yang terkirim sudah selesai.',
      link: 'Unduh'
    },

    empty_records: {
      body: 'Tidak ada catatan panggilan untuk periode yang dipilih'
    },

    button: {
      see_all: 'Lihat semunya'
    },

    export_type: {
      mailing_export_complete: 'SMS',
      senders_update: 'Pengirim',
      mailings_update: 'Pesan',
      voice_export_complete: 'Voice',
      database_export_complete: 'DB',
      pbx_export_complete: 'PBX',
      recording_export_complete: 'Rekaman PBX',
      stat_export_complete: 'Autoinformer',
      documents_update: 'Profile',
      rates_update: 'Pembaruan tarif',
      low_balance: 'Saldo rendah',
      custom: 'Pemberitahuan',
      not_enough_money: 'Dana tidak cukup',
      predictive_export_stats_complete : "Prediktif"
    }
  }
};
